import React from 'react';

export type ThemesTypes = 'light' | 'dark' | 'lac';

export interface IThemeContext {
  currentTheme: ThemesTypes;
  toogleTheme: (theme?: ThemesTypes) => void;
}

const ThemeContext = React.createContext<IThemeContext>(null);

export default ThemeContext;
